import React, { useEffect, useState, useContext } from 'react';
// import apiService from '../services/apiService';
import '../styles/pages/welcome.scss';
// import DBContext from '../dbcontext';
import { DateFormatter } from '../utils/DateFormatter';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import Open from "../assets/icons/open"
import WorkflowContext from '../workflowContext';

import axios from "axios"


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function Welcome() {
    // const database = useContext(DBContext);
    const workflow = useContext(WorkflowContext);
    const [userfullName, setUserFullName] = useState("");
    // const [workflowData, setWorkflowData] = useState([]);
    // const [finalData, setFinalData] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const name = localStorage.getItem('usernameDisplay');
        if (name) {
            setUserFullName(localStorage.getItem('usernameDisplay'))
        }
    }, [workflow]);

    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    // const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    // const [workflowDetails, setWorkflowDetails] = useState([]);
    const [workflowdata, setWorkflowdata] = useState([]);

    useEffect(() => {
        setLoading(true)

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getDataUserToken}`,
        };

        // axios.get( `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/workflow?userId=${userid}`, {
        axios.get( `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/workflowDsInfo?userId=${userid}`, {
        headers,
        }).then((response) => {

            // We only want to display the 10 most recent visualizations
            response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const slicedArray = response.data.slice(0, 10);

            setWorkflowdata(slicedArray);
        }).catch((error) => {
            console.log('Error in getting workflowdata', error);
        });

        setLoading(false)

    }, [getDataUserToken, userid]);

    // useEffect(() => {

    //     const headers = {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${getDataUserToken}`,
    //     };

    //     workflowdata.forEach((data) => {
    //         axios.get( `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/workflowDsInfo/${data.id}?userId=${userid}`, {
    //         headers,
    //         }).then((response) => {
    //             const data = response.data;
    //             console.log('data', data);



    //             // console.log('workflowDetails', workflowDetails);

    //             // const i = workflowDetails.findIndex(x => x.id == data.id)
    //             // console.log('i', i);

    //             // setWorkflowDetails(workflowDetails => [...workflowDetails, data]);


    //         }).catch((error) => {
    //             console.log('Error in getting workflowDetails', error);
    //         });
    //     })
    // }, [workflowdata]);


    // const getWorkflowDetail = async (data, dataList) => {
    //     await apiService.GetWorkflowDetails(data.id).then((res) => {
    //         const i = dataList.findIndex(x => x.id == data.id)
    //         let replacingData = { ...dataList[i], ...res.data }
    //         dataList[i] = replacingData
    //     }).catch(() => {
    //         const i = dataList.findIndex(x => x.id == data.id)
    //         let replacingData = { ...dataList[i] }
    //         dataList[i] = replacingData
    //     })
    //     setWorkflowData(dataList)
    // }

    // const getWorkflowData = async () => {
    //     setLoading(true)
    //     await apiService.GetWorkflow().then(function (response) {
    //         let dataList = response.data
    //         dataList?.length > 0 && dataList?.map((data) => {
    //             getWorkflowDetail(data, dataList)
    //         })
    //     });
    //     setLoading(false)
    // };

    // useEffect(() => {
    //     setFinalData(workflowData)
    // }, [workflowData])

    // useEffect(() => {
    //     getWorkflowData();
    // }, []);

    useEffect(() => {
        document.title = `Welcome | Palmona Pathogenomics`
    }, []);

    const [successDisplay, setSuccessDisplay] = useState(location.state?.workflowSuccess ? true : false)

    return (
        <div>
            {successDisplay && <div className="flex align-items-start p-4 bg-green-100 border-round border-1 border-green-300 position-fixed">
                <i className="pi pi-check-circle text-green-900 text-2xl mr-3"></i>
                <div className="mr-3">
                    <div className="text-green-900 font-medium text-xl mb-2 line-height-1">Success</div>
                    <p className="m-0 p-0 text-green-700 line-height-3">Your workflow is currently running. You may safely navigate away from this page.</p>
                </div>
                <div className="ml-auto">
                    <a onClick={() => setSuccessDisplay(false)} className="inline-flex align-items-center justify-content-center ml-auto border-circle hover:bg-green-50 no-underline cursor-pointer transition-colors transition-duration-150" style={{ width: '1.5rem', height: '1.5rem' }}>
                        <i className="pi pi-times text-green-900"></i>
                    </a>
                </div>
            </div>}
            <div className="welcome-container container-lg" >
                <div className="stat-box" >
                    <div>
                        <p style={{ fontWeight: "500" }}>Welcome,</p>
                        <h5>{userfullName}</h5>
                    </div>
                    <div>
                        {workflowdata.length > 0 ? <p style={{ margin: "0px", fontWeight: "500" }}>View Recent Visualizations</p> : <p style={{ margin: "0px", fontWeight: "500" }}> No Workflows created</p>}
                        <div style={{ border: "1.5px solid #f58220", margin: "0px 0px 10px 0px" }} />
                        {loading ?
                            <div className="loading">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                            :
                            <div>
                                {workflowdata.length > 0 && workflowdata?.map((visualisation, i) => {
                                    return (
                                        <div key={i}>
                                            <div className="row">
                                                <div className="col-6" style={{ paddingBottom: '0px' }}>
                                                    <div style={{ color: "#004D7A", fontWeight: '500' }}>
                                                        { visualisation.status === 'Success' &&
                                                            <Link to={`visualizations/?workflow=${visualisation.id}`}>{visualisation.name}</Link>
                                                        }
                                                        { visualisation.status !== 'Success' &&
                                                            <p>{visualisation.name}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-5 text-end" style={{ paddingBottom: '0px', fontSize: '12px' }}>
                                                    <div>{DateFormatter(visualisation.createdAt)}</div>
                                                </div>
                                                <div className="col-1" style={{ paddingBottom: '0px' }}>
                                                    { visualisation.status === 'Success' &&
                                                        <Open color={"#004D7A"} path={`visualizations/?workflow=${visualisation.id}`} />
                                                    }
                                                </div>
                                            </div>
                                            <div className='row' style={{ paddingBottom: '10px', fontSize: '12px' }}>
                                                <div className="col-6">{`Dataset ${visualisation.number_of_datasets ? visualisation.number_of_datasets : 0},  ${visualisation.number_of_samples ? visualisation.number_of_samples : 0} samples`}</div>
                                                <div className="col-5 text-end">Status: &nbsp;
                                                    { visualisation.status === 'Success' &&
                                                        <span className='text-success'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Failed' &&
                                                        <span className='text-danger'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Error' &&
                                                        <span className='text-danger'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Completed' &&
                                                        <span className='text-success'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'In Progress' &&
                                                        <span className='text-warning'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Sent' &&
                                                        <span className='text-info'>{visualisation.status}</span>
                                                    }                                                
                                                    { visualisation.status === 'New' &&
                                                        <span className='text-info'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Queued' &&
                                                        <span className='text-warning'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Running' &&
                                                        <span className='text-info'>{visualisation.status}</span>
                                                    }                                                                                                                                               
                                                    { visualisation.status === 'Pending' &&
                                                        <span className='text-warning'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Unknown' &&
                                                        <span className='text-warning'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Cancelled' &&
                                                        <span className='text-danger'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Aborted' &&
                                                        <span className='text-danger'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Paused' &&
                                                        <span className='text-warning'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Resumed' &&
                                                        <span className='text-warning'>{visualisation.status}</span>
                                                    }
                                                    { visualisation.status === 'Stopped' &&
                                                        <span className='text-danger'>{visualisation.status}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
